(function(){
if(!customElements.get('atelier-edition-stock')){
 class EditionStock extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   this.readData();this.form=document.getElementById(this.dataset.formId);
   this.onVariant=(event)=>{if(event.detail && event.detail.variant){this.selected=event.detail.variant.id;this.render();}};
   this.onChange=()=>setTimeout(()=>{var input=this.form && this.form.querySelector('[name="id"]');if(input){this.selected=Number(input.value);this.render();}},0);
   if(this.form){this.form.addEventListener('variant:changed',this.onVariant);this.form.addEventListener('change',this.onChange);}
   this.render();this.timer=setInterval(()=>{if(!document.hidden)this.refresh();},60000);
  }
  readData(){try{this.data=JSON.parse(this.querySelector('[data-edition-data]').textContent);this.selected=this.selected||this.data.selected;}catch(error){this.data={variants:[]};}}
  current(){return this.data.variants.find(v=>String(v.id)===String(this.selected));}
  render(){
   var v=this.current(),title=this.querySelector('[data-edition-title]'),detail=this.querySelector('[data-edition-detail]'),track=this.querySelector('[data-edition-track]'),fill=this.querySelector('[data-edition-fill]');
   if(!v)return;
   var qty=null,total=Math.max(1,Number(this.data.total)||100);
   if(v.tracked && v.policy==='deny')qty=Math.max(0,Number(v.quantity)||0);
   else if(this.data.preview && !v.tracked)qty=Math.max(0,Number(this.data.remaining)||0);
   track.hidden=true;
   if(qty===null){title.textContent=v.available?'Edition availability':'Currently unavailable';detail.textContent='Contact an advisor for current availability.';return;}
   title.textContent=qty===0?'This selection is currently unavailable':qty===1?'Only 1 piece remaining':qty+' pieces remaining';
   if(qty<=total){
    track.hidden=false;fill.style.width=Math.max(0,Math.min(100,(total-qty)/total*100))+'%';
    detail.textContent=qty+' of '+total+' pieces available in this edition';
   }else{detail.textContent='Availability for the selected edition.';}
  }
  async refresh(){
   var v=this.current();if(!v || !v.tracked || this.refreshing)return;
   this.refreshing=true;
   try{
    var url=new URL(this.dataset.productUrl,location.origin);url.searchParams.set('section_id',this.dataset.sectionId);url.searchParams.set('variant',this.selected);
    var response=await fetch(url,{credentials:'same-origin',cache:'no-store'});if(!response.ok)return;
    var doc=new DOMParser().parseFromString(await response.text(),'text/html');
    var node=doc.querySelector('atelier-edition-stock[data-product-id="'+this.dataset.productId+'"] [data-edition-data]');
    if(node){this.data=JSON.parse(node.textContent);this.render();}
   }catch(error){}finally{this.refreshing=false;}
  }
  disconnectedCallback(){
   clearInterval(this.timer);
   if(this.form){this.form.removeEventListener('variant:changed',this.onVariant);this.form.removeEventListener('change',this.onChange);}
   this.ready=false;
  }
 }
 customElements.define('atelier-edition-stock',EditionStock);
}
if(!customElements.get('atelier-product-delivery')){
 var locationPromise;
 function country(){
  if(locationPromise)return locationPromise;
  try{var saved=JSON.parse(sessionStorage.getItem('atelier_shopify_ip_country_v1'));if(saved && Date.now()-saved.time<1800000 && typeof saved.name==='string')return locationPromise=Promise.resolve(saved.name);}catch(error){}
  var controller=new AbortController(),timer=setTimeout(()=>controller.abort(),5000);
  locationPromise=fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/')+'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false',{credentials:'same-origin',signal:controller.signal})
   .then(r=>{if(!r.ok)throw new Error('Location unavailable');return r.json();})
   .then(data=>{var c=data.detected_values && data.detected_values.country;if(!c || typeof c.name!=='string' || !/^[A-Z]{2}$/.test(c.handle||''))return '';try{sessionStorage.setItem('atelier_shopify_ip_country_v1',JSON.stringify({name:c.name,time:Date.now()}));}catch(error){}return c.name;})
   .catch(()=> '').finally(()=>clearTimeout(timer));
  return locationPromise;
 }
 customElements.define('atelier-product-delivery',class extends HTMLElement{
  connectedCallback(){country().then(name=>{var target=this.querySelector('[data-premium-country]');if(target && this.isConnected && name)target.textContent=' to '+name;});}
 });
}
})();
(function(){
if(customElements.get('atelier-buy-now'))return;
customElements.define('atelier-buy-now',class extends HTMLElement{
 connectedCallback(){
  if(this.bound)return;this.bound=true;
  this.form=document.getElementById(this.dataset.formId);this.button=this.querySelector('button');this.error=this.querySelector('[role="alert"]');
  this.onVariant=(event)=>{if(event.detail && event.detail.variant)this.button.disabled=!event.detail.variant.available;};
  if(this.form)this.form.addEventListener('variant:changed',this.onVariant);
  this.onClick=async()=>{
   if(!this.form || !this.form.reportValidity() || this.busy)return;
   this.busy=true;this.button.disabled=true;this.button.textContent='Preparing checkout…';this.error.hidden=true;
   try{
    var root=window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    var response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:new FormData(this.form)});
    var result=await response.json();if(!response.ok)throw new Error(result.description || result.message || 'Please try again.');
    window.location.assign(root+'checkout');
   }catch(error){this.error.textContent=error.message || 'Please try again.';this.error.hidden=false;this.button.disabled=false;this.button.textContent='Buy now';this.busy=false;}
  };
  this.button.addEventListener('click',this.onClick);
 }
 disconnectedCallback(){if(this.form)this.form.removeEventListener('variant:changed',this.onVariant);if(this.button)this.button.removeEventListener('click',this.onClick);this.bound=false;}
});
})();